import React from 'react';
import cls from '@utils/css-select';

import styles from './styles.scss';
import Section from 'components/section';
const cx = cls(styles);

const roomFunMap = [
	{
		icon: 'https://web-data.zmlearn.com/image/cSXrX1PUMqBpMRM929Y2Jj/platform_icon_1%402x.png',
		title: 'Real-time communication via video',
	},
	{
		icon: 'https://web-data.zmlearn.com/image/76wHBuhXhR1Bw1MxgpXKqM/platform_icon_2%402x.png',
		title: 'Synchronous practice through class tools',
	},
	{
		icon: 'https://web-data.zmlearn.com/image/joJuvSv2cRkLbrXkUcXjZX/platform_icon_3%402x.png',
		title: 'Courses shared within courseware area',
	},
];
const ClassroomImg = 'https://web-data.zmlearn.com/image/r6H7dxYbpaAu8RyRbDZfNN/platform_1%402x.png';

export default function ClassroomBox() {
	return (
		<div className={cx('classroom-block')}>
			<Section>
				<h3 className={cx('classroom-title', 'block-title')}>Immersive and interactive teaching platform</h3>
				<div className={cx('content')}>
					<div className={cx('room-fun-list')}>
						{roomFunMap.map((item) => {
							return (
								<dl key={item.title} className={cx('fun-item')}>
									<dd>
										<img loading="lazy" src={item.icon} alt="" />
									</dd>
									<dl>{item.title}</dl>
								</dl>
							);
						})}
					</div>
					<div className={cx('fun-guides')}>
						<img loading="lazy" src={ClassroomImg} alt="" />
						<div className={cx('guide-item')}>
							Courseware area
							<span></span>
						</div>
						<div className={cx('guide-item')}>
							Real-time conversation
							<span></span>
						</div>
						<div className={cx('guide-item')}>
							Class tools
							<span></span>
						</div>
						<div className={cx('guide-item')}>
							Class tools
							<span></span>
						</div>
					</div>
				</div>
			</Section>
		</div>
	);
}
